import React, { Component, createRef } from "react";
import { immediateToast } from "izitoast-react";
import { connect } from "react-redux";
import DatePicker from "react-date-picker";
import Select from "react-select";

import CustomWorkout from "../CustomWorkout/CustomWorkout";
import Lift from "../Lift/Lift";
import FromDatabase from "../FromDatabase/FromDatabase";
import AddScore from "../AddScore/AddScore";

import style from "./workoutCard.module.css";

import { callAPI } from "../../assets/Js/backendCommunication";

import projectSettings from "../../assets/Js/projectSettings";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { findMonth } from "../../assets/Js/findMonth";

import workoutApiCalled from "../../redux/actionCreators/workoutApiCalled";
import shouldDuplicate from "../../redux/actionCreators/shouldDuplicate";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";
import ViewWorkout from "../../Components/ViewWorkouts/ViewWorkout";
import ViewScore from "../ViewScore/ViewScore";
import ErrorBoundary from "../ErrorBoundery/ErrorBoundery";
import { ScoreType } from "../../assets/Js/scoreEnum";

const mapDispatchToProps = (dispatch) => {
  return {
    workoutApiCalled: () => dispatch(workoutApiCalled()),
    shouldDuplicate: (data) => {
      return dispatch(shouldDuplicate(data));
    },
  };
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    gymDataTrack: state.gymData,
    trackInfo: state.trackInfo,
    isDuplicate: state.isDupilicate,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class WorkoutCard extends Component {
    constructor(props) {
      super(props);

      this.dateRef = createRef();

      this.state = {
        showCustomWorkout: true,
        showLift: false,
        showFromDB: false,
        showAddWorkout: false,
        showScore: 0,
        showScoreDetails: 0,
        workout: this.props.workout,
        type: "",
        workoutDate: this.props.workout
          ? this.props.workout.Schedule
          : this.props.tileDate,
        trackid: "",
        selectedTrack: {},
        tracks: [],
        trackOptions: [],
        showWorkoutModal: false,
        duplicateTrackId: null,
        showAddScoreModal: false,
      };
    }

    componentDidMount() {
      this.getDateFormat1(this.props.tileDate);

      this.setState({
        type:
          this.props &&
          this.state.workout &&
          this.state.workout.WorkoutType.toLowerCase(),
      });

      if (
        this.props &&
        this.state.workout &&
        this.state.workout.WorkoutType.toLowerCase() === "custom"
      ) {
        this.setState({
          showCustomWorkout: true,
          showLift: false,
          showFromDB: false,
        });
      } else if (
        this.props &&
        this.state.workout &&
        this.state.workout.WorkoutType.toLowerCase() === "deadlift"
      ) {
        this.setState({
          showCustomWorkout: false,
          showFromDB: false,
        });
      }
      if (this.props.trackInfo) {
        this.handleTrackData();
      }
    }

    handleTrackData = () => {
      const tempOptions1 = this.props.gymDataTrack[0]?.Tracks.map(
        (currVal, index) => ({
          value: currVal.Id,
          label: currVal.Name,
        })
      );
      this.setState({
        tracks: this.props.gymDataTrack[0]?.Tracks,
        selectedTrack: this.props?.trackInfo,
        trackOptions: tempOptions1,
        duplicateTrackId: this.props?.trackInfo?.Id,
      });
    };

    static getDerivedStateFromProps(newProps, prevProps) {
      let tileDate = newProps.tileDate;

      return {
        ...prevProps,
        tileDate: tileDate,
      };
    }

    componentDidUpdate = (prevProps) => {
      if (prevProps.tileDate !== this.props.tileDate) {
        this.setState({ workoutDate: this.props.tileDate });
      }
      if (prevProps.trackInfo !== this.props.trackInfo) {
        this.handleTrackData();
      }
    };

    setDate = (date) => {
      this.setState({ workoutDate: date });
    };

    getDateFormat1 = (reqDate) => {
      let tempDate = new Date(reqDate);
      let date = tempDate.getDate();
      let month = tempDate.getMonth();
      let year = tempDate.getFullYear();

      let newDate = `${month + 1}/${date}/${year}`;

      return newDate;
    };

    getDateFormat2 = (reqDate) => {
      let tempDate = new Date(reqDate);
      let date = tempDate.getDate();
      let month = tempDate.getMonth();
      let year = tempDate.getFullYear();

      let newDate = `${findMonth(month)},${date} ${year}`;
      return newDate;
    };

    deleteWorkoutRequest = async () => {
      let workoutid = this.state.workout.Id;
      let url = `${projectSettings.baseUrl}/workouts/delete/${workoutid}`;
      let header = true;
      let type = "POST";
      let token = getPlainToken();
      let data = null;

      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, data, token);

      if (response) {
        apiResponseToast(response.status, "removeWorkout");

        this.setState({ isLoading: false });
        if (response.type === "error") {
        } else if (response.type === "success") {
          this.props.workoutApiCalled();

          response = "";
        }
      }
    };

    removeWorkout = () => {
      new Promise((resolve) => {
        immediateToast("question", {
          timeout: 20000,
          close: false,
          overlay: true,
          displayMode: "once",
          id: "question",
          zindex: 9999,
          title: "Delete Request",
          message: "Are you sure about that?",
          position: "center",
          buttons: [
            [
              `<button><b>YES</b></button>`,
              function (instance, toast) {
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");

                resolve("yes");
              },
              true,
            ],
            [
              `<button>NO</button>`,
              function (instance, toast) {
                instance.hide({ transitionOut: "fadeOut" }, toast, "button");
              },
            ],
          ],
        });
      })
        .then((responce) => {
          this.deleteWorkoutRequest();
        })
        .catch((err) => console.error("error:", err));
    };

    forward = () => {
      this.setState({ showAddScore: true });
    };

    back = () => {
      this.setState({ showAddScore: false });
      this.props.shouldDuplicate(false);
    };

    backScoreDetials = () => {
      this.setState((prev) => ({
        showScoreDetails: prev.showScoreDetails - 1,
      }));
      this.props.shouldDuplicate(false);
    };

    resetScoreDetails = () => {
      this.setState({
        showScoreDetails: 0,
      });
      this.props.shouldDuplicate(false);
    };

    forwardScoreDetials = (value) => {
      this.setState((prev) => ({
        showScoreDetails: value,
      }));
    };

    newDescription(description) {
      var repsPercentage = {
        percentageValue: "",
        reps: "",
      };
      let i = 0;
      let newDescription = "";
      var str = description;
      do {
        repsPercentage = {
          percentage: "",
          resp: "",
        };

        if (str.indexOf("#") === -1 || str.indexOf("\n") === -1) break;
        let index1 = str.indexOf("#"),
          index2 = str.indexOf("\n");
        var subStr = str.slice(index1, ++index2);
        var repsIndex = subStr.indexOf("Reps");
        var startReps = "#" + (i + 1) + ": ";
        let newPercentage = subStr.slice(repsIndex + 5, subStr.indexOf("%"));
        if (newPercentage === "0" || newPercentage === "100") {
          newPercentage = "";
        }
        repsPercentage = {
          percentage: newPercentage,
          reps: subStr.slice(startReps.length, repsIndex),
        };
        newDescription += `#${i + 1} :  ${repsPercentage.reps}  Reps ${
          repsPercentage.percentage
        }${repsPercentage.percentage && "%"}\n`;
        str = str.replace(subStr, "");
        i++;
      } while (true);
      return newDescription;
    }

    changeSelectedTrack = (selectedTrackName) => {
      let reqTrack = this.state.tracks.filter((track) => {
        if (track.Name === selectedTrackName) {
          return track;
        }
      });
      this.setState({
        selectedTrack: reqTrack[0],
        duplicateTrackId: reqTrack[0].Id,
      });
    };

    handleAddScore = (isShow) => {
      this.setState({
        showAddScoreModal: isShow,
      });
    };

    duplicateWorkout = () => {
      let customWorkout = false;
      let customShowLift = false;
      let workoutType = this.state.workout.WorkoutType.toLowerCase();
      if (workoutType === "custom" || workoutType === "database") {
        customWorkout = true;
      } else if (workoutType === "deadlift") {
        customShowLift = true;
      }
      this.setState({
        showCustomWorkout: customWorkout,
        showLift: customShowLift,
      });
      this.props.shouldDuplicate(true);
    };

    reset = () => {
      this.props.shouldDuplicate(false);

      this.setState({
        showCustomWorkout: true,
        showLift: false,
        showFromDB: false,
        showAddWorkout: false,
        showScore: 0,
        showScoreDetails: 0,
        workout: this.props.workout,
        type: "",
        workoutDate: this.props.workout
          ? this.props.workout.Schedule
          : this.props.tileDate,
        trackid: "",
        showWorkoutModal: false,
      });
    };

    render() {
      const isGymOwner = this?.props?.userData?.Role === "owner";

      return (
        <>
          {this.state.workout ? (
            <div className={`p-1 ${style.container}`}>
              <div className="mb-1">
                <div
                  className={`${style.contentBox} secondaryScrollBar ${
                    !isGymOwner && "pointerCursor"
                  }`}
                  data-toggle="modal"
                  data-target={`#viewModal${this.state.workout.Id}`}
                  onClick={() => {
                    this.props.shouldDuplicate(false);
                  }}
                >
                  <div className="d-flex  justify-content-between">
                    <div className={`h5 p-0 m-0 mb-1 ${style.workoutBox}`}>
                      {this.state.workout.Name}
                    </div>
                  </div>
                  {this.state.workout.WorkoutType.toLowerCase() === "custom" ||
                  this.state.workout.WorkoutType.toLowerCase() ===
                    "database" ? (
                    <div>{this.state.workout.Description}</div>
                  ) : (
                    <div className="stringCodeFomrat">
                      {this.props.workout.WorkoutType.toLowerCase() ===
                      "deadlift"
                        ? this.newDescription(this.state.workout.Description)
                        : this.state.workout.Description}
                    </div>
                  )}
                </div>
              </div>

              {this.props.userData.Role === "owner" &&
                this.state.workout.WorkoutType.toLowerCase() !== "database" && (
                  <div className={style.editIconBox}>
                    <span
                      tooltip="Edit"
                      flow="left"
                      className={`${style.editIcon}`}
                    >
                      <i
                        className={`mdi mdi-lead-pencil pointerCursor`}
                        data-toggle="modal"
                        data-target={`#workoutModal${this.state.workout.Id}`}
                        onClick={(e) => {
                          let _isCustom =
                            this.state.workout.WorkoutType.toLowerCase() ===
                            "custom";
                          let _isDeadlift =
                            this.state.workout.WorkoutType.toLowerCase() ===
                            "deadlift";

                          this.props.shouldDuplicate(false);
                          this.setState({
                            showCustomWorkout: _isCustom,
                            showLift: _isDeadlift,
                          });
                        }}
                      ></i>
                    </span>
                  </div>
                )}

              <div className="mt-1 d-flex justify-content-between">
                <div>
                  {this.state.workout.ScoreType !== ScoreType.text && (
                    <span
                      tooltip="View Score"
                      flow="right"
                      onClick={() => {
                        this.setState({ showScore: ++this.state.showScore });
                      }}
                    >
                      <i
                        className="mdi mdi-eye mr-2 pointerCursor"
                        data-toggle="modal"
                        data-target={`#viewScore${this.state.workout.Id}`}
                      ></i>
                    </span>
                  )}
                  {this.props.workout.WorkoutType.toLowerCase() !==
                    "database" &&
                    this.props.userData.Role.toLowerCase() === "owner" && (
                      <span tooltip="Edit" flow="right">
                        <i
                          className="mdi mdi-menu mr-2 pointerCursor"
                          data-toggle="modal"
                          data-target={
                            this.props.userData.Role === "owner"
                              ? `#workoutModal${this.state.workout.Id}`
                              : `#viewModal${this.state.workout.Id}`
                          }
                          onClick={() => {
                            let _isCustom =
                              this.state.workout.WorkoutType.toLowerCase() ===
                              "custom";
                            let _isDeadlift =
                              this.state.workout.WorkoutType.toLowerCase() ===
                              "deadlift";

                            this.props.shouldDuplicate(false);
                            this.setState({
                              showCustomWorkout: _isCustom,
                              showLift: _isDeadlift,
                            });
                          }}
                        ></i>
                      </span>
                    )}
                  {this.state.workout.ScoreType !== ScoreType.text && (
                    <span tooltip="Add Score" flow="right">
                      <i
                        className="mdi mdi-plus pointerCursor"
                        data-toggle="modal"
                        onClick={() => this.handleAddScore(true)}
                        data-target={`#addScore${this.state.workout.Id}`}
                      ></i>
                    </span>
                  )}
                </div>
                {this.props.userData.Role === "owner" && (
                  <div>
                    <span tooltip="Duplicate" flow="left">
                      <i
                        className="mdi mdi-content-duplicate pointerCursor"
                        data-toggle="modal"
                        data-target={`#workoutModal${this.state.workout.Id}`}
                        onClick={this.duplicateWorkout}
                      ></i>
                    </span>
                    {this.state.workout.WorkoutType.toLowerCase() !==
                      "database" && (
                      <span tooltip="Delete" flow="left">
                        <i
                          className="mdi mdi-delete ml-2 pointerCursor"
                          onClick={(index) => {
                            this.removeWorkout();
                          }}
                          data-target="tooltip"
                        ></i>
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <>
              {this.props.userData.Role === "owner" && (
                <div
                  className="colorBgWhite quinaryColor rounded p-2 pointerCursor"
                  data-target={`#workoutModal`}
                  onClick={() => {
                    this.setState({ showWorkoutModal: true });
                  }}
                >
                  <i className="mdi mdi-plus menu-icon"></i>
                  <span className="ml-2">Add Workout</span>
                </div>
              )}
            </>
          )}
          {/* Workout Modal */}
          <div
            className={`modal fade pointerContextMenu ${
              this.state.showWorkoutModal ? "show modalOverlay" : "hide"
            }`}
            style={{ display: this.state.showWorkoutModal ? "block" : "none" }}
            id={
              this.state.workout
                ? `workoutModal${this.state.workout.Id}`
                : "workoutModal"
            }
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div className="modal-dialog updateModalDialog" role="document">
              <div className="modal-content modalContainer1 border-0">
                <div class="modal-header">
                  <div className="d-flex">
                    <h5 class="modal-title">Add Workout</h5>
                  </div>
                  <div>
                    {/* Cross Button to close modal */}
                    <button
                      type="button"
                      className="noBgBtn"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.reset}
                    >
                      <span aria-hidden="true" className="mdi mdi-close"></span>
                    </button>
                  </div>
                </div>
                {this.props.isDuplicate && (
                  <div className="mr-2 ml-2 mb-0">
                    <div className="mb-1">Tracks</div>
                    <Select
                      className={`react-select`}
                      placeholder="Tracks"
                      value={{
                        label:
                          this.state.selectedTrack &&
                          this.state.selectedTrack.Name,
                      }}
                      options={this.state.trackOptions}
                      onChange={(selctedOption) => {
                        this.setState(
                          this.changeSelectedTrack(selctedOption.label)
                        );
                      }}
                    />
                  </div>
                )}
                <div class="border rounded inputFieldStyle m-2">
                  <DatePicker
                    clearIcon={null}
                    onChange={(value) => {
                      this.setDate(value);
                    }}
                    value={new Date(this.state.workoutDate)}
                    className="form-control form-control-sm colorBgWhite p-0"
                  />
                </div>
                <div className="d-flex justify-content-between mt-2 mb-2 ml-3 mr-3">
                  <button
                    className={`basicBtnStyle p-2 workOutBtn ${
                      this.state.showCustomWorkout
                        ? "primaryBtn"
                        : "quaternaryBtn"
                    }`}
                    onClick={() => {
                      this.setState({
                        showCustomWorkout: true,
                        showLift: false,
                        showFromDB: false,
                      });
                    }}
                    disabled={
                      !this.state.workout
                        ? false
                        : !this.state.showCustomWorkout
                    }
                  >
                    Custom Workout
                  </button>
                  <button
                    className={`basicBtnStyle p-2 workOutBtn ${
                      this.state.showLift ? "primaryBtn" : "quaternaryBtn"
                    }`}
                    onClick={() => {
                      this.setState({
                        showCustomWorkout: false,
                        showLift: true,
                        showFromDB: false,
                      });
                    }}
                    disabled={
                      !this.state.workout ? false : !this.state.showLift
                    }
                  >
                    Lift
                  </button>
                  <button
                    className={`basicBtnStyle p-2 workOutBtn ${
                      this.state.showFromDB ? "primaryBtn" : "quaternaryBtn"
                    }`}
                    onClick={() => {
                      this.setState({
                        showCustomWorkout: false,
                        showLift: false,
                        showFromDB: true,
                      });
                    }}
                    disabled={
                      !this.state.workout ? false : !this.state.showFromDB
                    }
                  >
                    From Database
                  </button>
                </div>

                <div className="dropdown-divider"></div>
                <div className="modal-body  modal-scroll primaryScrollBar">
                  {this.state.showCustomWorkout ? (
                    this.state.workout ? (
                      <CustomWorkout
                        editableWorkout={this.state.workout}
                        modalId={`workoutModal${this.state.workout.Id}`}
                        workoutDate={this.state.workoutDate}
                        trackWorkoutId={this.props.trackWorkoutId}
                        duplicateTrackId={this.state.duplicateTrackId}
                        closeModal={this.reset}
                      />
                    ) : this.state.showWorkoutModal ? (
                      <CustomWorkout
                        modalId="workoutModal"
                        workoutDate={this.state.workoutDate}
                        closeModal={this.reset}
                      />
                    ) : null
                  ) : this.state.showLift ? (
                    this.state.workout ? (
                      <Lift
                        editableWorkout={this.state.workout}
                        modalId={`workoutModal${this.state.workout.Id}`}
                        workoutDate={this.state.workoutDate}
                        duplicateTrackId={this.state.duplicateTrackId}
                        trackWorkoutId={this.props.trackWorkoutId}
                        closeModal={this.reset}
                      />
                    ) : (
                      <Lift
                        modalId="workoutModal"
                        workoutDate={this.state.workoutDate}
                        closeModal={this.reset}
                      />
                    )
                  ) : this.state.showFromDB ? (
                    this.state.workout ? (
                      <FromDatabase
                        workoutDate={this.state.workoutDate}
                        modalId={`workoutModal${this.state.workout.Id}`}
                        trackWorkoutId={this.props.trackWorkoutId}
                        closeModal={this.reset}
                      />
                    ) : (
                      <FromDatabase
                        workoutDate={this.state.workoutDate}
                        modalId="workoutModal"
                        closeModal={this.reset}
                      />
                    )
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          {/* Workout Modal ends */}

          {/* Add score modal */}
          <div
            className={`modal fade pointerContextMenu`}
            id={
              this.state.workout
                ? `addScore${this.state.workout.Id}`
                : "addScore"
            }
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div className="modal-dialog basicFormStyle" role="document">
              <div className="modal-content modalContainer1  border-0 modalRounded">
                <div class="modal-header">
                  <div className="d-flex">
                    <h5 class="modal-title">Add Score</h5>
                  </div>
                  <div>
                    {/* Cross Button to close modal */}
                    <button
                      type="button"
                      className="noBgBtn"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        this.handleAddScore(false);
                      }}
                    >
                      <span aria-hidden="true" className="mdi mdi-close"></span>
                    </button>
                  </div>
                </div>
                <div className="modal-body modal-scroll primaryScrollBar">
                  {this.props.trackWorkoutId &&
                    this.state.showAddScoreModal && (
                      <AddScore
                        workout={this.state.workout}
                        trackWorkoutId={this.props.trackWorkoutId}
                        handleAddScore={this.handleAddScore}
                      />
                    )}
                </div>
              </div>
            </div>
          </div>
          {/* add score Modal ends */}

          {/* View Modal */}
          <div
            class="modal fade pointerContextMenu"
            id={this.state.workout && `viewModal${this.state.workout.Id}`}
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div class="modal-dialog basicFormStyle" role="document">
              <div class="modal-content border-0 modalRounded">
                <div class="modal-header">
                  <div>
                    <button
                      className={`noBgBtn mr-2 ${
                        !this.state.showAddScore && "d-none"
                      }`}
                      onClick={this.back}
                    >
                      <span className="mdi mdi-arrow-left"></span>
                    </button>
                  </div>
                  <h5 class="modal-title">
                    {this.state.workout &&
                      (this.state.showAddScore
                        ? this.state.workout.Name
                        : this.getDateFormat2(this.props.tileDate))}
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this.back}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body  pt-4  modal-scroll primaryScrollBar">
                  {
                    <ViewWorkout
                      trackWorkoutId={this.props.trackWorkoutId}
                      workout={this.state.workout}
                      modalId={
                        this.state.workout &&
                        `viewModal${this.state.workout.Id}`
                      }
                      showAddScore={this.state.showAddScore}
                      back={this.back}
                      forward={this.forward}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
          {/* View Modal ends */}

          {/* View Score */}
          <div
            class="modal fade pointerContextMenu"
            id={this.state.workout && `viewScore${this.state.workout.Id}`}
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div class="modal-dialog basicFormStyle" role="document">
              <div class="modal-content border-0 modalRounded secondaryScrollBar">
                <div class="modal-header">
                  <button
                    className={`noBgBtn ${
                      !this.state.showScoreDetails && "d-none"
                    }`}
                    onClick={this.backScoreDetials}
                  >
                    <span className="mdi mdi-arrow-left mr-2"></span>
                  </button>
                  <h5 class="modal-title">View Score</h5>
                  <button
                    type="button"
                    className="noBgBtn"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this.resetScoreDetails}
                  >
                    <span aria-hidden="true" className="mdi mdi-close"></span>
                  </button>
                </div>
                <div class="modal-body p-0 modal-scroll primaryScrollBar">
                  <ErrorBoundary>
                    {this.state.showScore && this.state.workout && (
                      <ViewScore
                        trackWorkoutId={this.props.trackWorkoutId}
                        scoreType={this.props.workout.ScoreType}
                        forward={this.forwardScoreDetials}
                        defaultScoreDetails={this.state.showScoreDetails}
                        showScore={this.state.showScore}
                        back={this.backScoreDetials}
                        modalId={
                          this.state.workout &&
                          `viewScore${this.state.workout.Id}`
                        }
                      />
                    )}
                  </ErrorBoundary>
                </div>
              </div>
            </div>
          </div>
          {/* View Score ends */}
        </>
      );
    }
  }
);
